import React from 'react';
import Details from '../components/company/details'; 
import Features from '../components/company/products';       

const CompanyDetails = () => {
    return (
        <div> 
            <Details />
            
        </div>
    );
};

export default CompanyDetails;